import { accountService } from '@/core/services/account-service';
import { t } from 'i18next';
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import CustomStore from 'devextreme/data/custom_store';

const AccountList = () => {
    const [store, setStore] = useState<CustomStore>();
    useEffect(() => {
        setStore(new CustomStore({
            key: ["id"],
            load: accountService.accountList,
            byKey: async (key, loadOptions: any) => {
                let returnObject = null;
                if (key) {
                    loadOptions.filter = ["Id", "=", key];
                    const objectsByID = (await accountService.accountList(loadOptions))
                    returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
                }
                return returnObject
            },
            remove: accountService.deleteAccount,
            useDefaultSearch: true
        }));
    }, [])

    const navigate = useNavigate();
    const goToEdit = (id: string) => {
        navigate(`/account-definition/${id}`, { state: { id: id } })
    }
    return (
        <>
            <DataGridWrapper
                datasource={store}
                permissonCode='Account.Account'
                pagerVisible={true}
                filterVisible={true}
                headerFilterVisible={true}
                enableCustomToolbarContent={true}
                navigateNewRecordPath='/account-definition'
                editingConfig={{
                    allowDeleting: true,
                    allowUpdating: true,
                    deleteMessageText: RemoveMessage('Account'),
                }}
                columns={[
                    { dataField: 'name', caption: t('account_name') },
                    { dataField: 'accountNumber', caption: t('account_number') },
                    { dataField: 'parentAccountName', caption: t('parent_account') }
                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: function (e: any) {
                            goToEdit(e.row?.data.id);
                        },
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                    },
                ]}
            />
        </>
    )
}
export default AccountList